import { useCallback } from 'react';
import { preferencesActions, preferencesSelectors } from 'app-components/flux/preferences';
import { useDispatch, useSelector } from 'react-redux';

function useQPreferences() {
  const dispatch = useDispatch();

  const setPreference = useCallback(
    (payload, meta) => dispatch(preferencesActions.setPreference(payload, meta)),
    [dispatch],
  );

  const getSharedPreferences = useCallback(() => {
    dispatch(preferencesActions.getPreferences({ section: 'shared', group: 'user' }));
    dispatch(preferencesActions.getPreferences({ section: 'shared', group: 'dataset' }));
  }, [dispatch]);

  const setDatasetPreference = useCallback(
    (prefObj) => {
      dispatch(
        preferencesActions.setPreference(
          {
            section: 'shared',
            group: 'dataset',
            preference: { webApp: prefObj },
          },
          { context: 'QPreferences:setDatasetPreference' },
        ),
      );
    },
    [dispatch],
  );

  const setUserPreference = useCallback(
    (prefObj) => {
      dispatch(
        preferencesActions.setPreference(
          {
            section: 'shared',
            group: 'user',
            preference: { webApp: prefObj },
          },
          { context: 'SetupPageAcme:setUserPreference' },
        ),
      );
    },
    [dispatch],
  );

  const loadPending = useSelector(preferencesSelectors.getLoadPending);
  const datasetPreferences = useSelector((state) =>
    preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset', path: ['webApp'] }),
  );
  const userPreferences = useSelector((state) =>
    preferencesSelectors.getSharedPreferencesByPath(state, { group: 'user', path: ['webApp'] }),
  );
  const sharedUserPreferences = useSelector((state) =>
    preferencesSelectors.getSharedPreferencesByPath(state, { group: 'user' }),
  );
  const sharedDatasetPreferences = useSelector((state) =>
    preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset' }),
  );
  const accountPreferencesById = useSelector((state) => preferencesSelectors.accountPreferencesById(state));

  return {
    setPreference,
    getSharedPreferences,
    setDatasetPreference,
    setUserPreference,
    datasetPreferences,
    userPreferences,
    sharedUserPreferences,
    sharedDatasetPreferences,
    accountPreferencesById,
    loadPending,
  };
}

export default useQPreferences;
